import React, { useState, useEffect } from "react";
import Footer from "./components/menu/footer";
import NavbarUserSesion from "./components/menu/navbarUserSesion";
import { FaCheck } from "react-icons/fa";
import { FaHouseSignal } from "react-icons/fa6";
import { ModalContainer } from "./components/modal/modalcontaimer";
import { PaymentForm } from "./components/client/paymentForm";
import { MdClose } from "react-icons/md";
import { AiOutlineBank } from "react-icons/ai";

const Home = () => {

  const [showModal, setShowModal] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (!showModal) {
      const storedUserData = localStorage.getItem("userSession");
      if (storedUserData) {
        const parsedData = JSON.parse(storedUserData);
        setUserData(parsedData.cliente);
      }
    }
  }, [showModal]);



  return (
    <div className="min-h-screen bg-purple-200">
      <NavbarUserSesion />

      <div className="pt-[85px] pb-5 px-4 max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-8 tracking-tight 
             bg-gradient-to-r from-gray-900 via-purple-600 to-gray-400 
             bg-clip-text text-transparent">
          Dashboard - Panel de usuario
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Card de Estado y Datos */}
          <div className="bg-white/80 backdrop-blur shadow-xl rounded-2xl p-6 transition hover:scale-[1.01]">
            <div className="flex flex-col items-center text-center">
              <FaHouseSignal className="text-6xl text-purple-700 mx-auto mb-2" />
              <p className="inline-block bg-green-500 text-white px-4 py-1 rounded-full text-sm">
                {userData?.Conexion[0]?.EstadoServicio || "Cargando estado..."}
              </p>
            </div>

            {userData && (
              <>
                <div className="space-y-2 mb-3">
                  <h2 className="text-xl font-semibold text-gray-700">
                    Datos del Cliente
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-gray-600">
                    <p>
                      <strong>Cliente:</strong> {userData.Cliente}
                    </p>
                    <p>
                      <strong>ID Roela:</strong> {userData?.Conexion[0]?.IdRoela}
                    </p>
                    <p>
                      <strong>Tel:</strong> {userData.Celular}
                    </p>
                    <p>
                      <strong>Email:</strong> {userData.Email}
                    </p>
                    <p>
                      <strong>Saldo:</strong>{" "}
                      {new Intl.NumberFormat("es-AR", {
                        style: "currency",
                        currency: "ARS",
                      }).format(userData.Saldo || 0)}
                    </p>
                  </div>
                </div>

                {userData.Conexion.map((conexion, index) => (
                  <div key={index} className="border-t my-4 border-purple-400 py-2">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">
                      Conexión #{index + 1}
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-gray-600">
                      <p >
                        <strong>Estado Pago:</strong>{" "}
                        <span
                          className={`
                          text-white px-2 py-1 rounded font-medium
                          ${conexion.estadoPago === "Al día" ? "bg-green-500" : ""}
                          ${conexion.estadoPago === "Con deuda" ? "bg-orange-400" : ""}
                          ${conexion.estadoPago === "Bloqueado" ? "bg-red-500" : ""}
                              `}
                        >
                          {conexion.estadoPago}
                        </span>
                      </p>
                      <p>
                        <strong>Plan:</strong> {conexion.Plan}
                      </p>
                      <p>
                        <strong>Tipo:</strong> {conexion.TipoConexion}
                      </p>
                      <p >
                        <strong>Domicilio:</strong> {conexion.Domicilio}
                      </p>

                    </div>
                  </div>
                ))}

                <div className="bg-gradient-to-r from-purple-500 to-purple-700 my-6 rounded-xl p-4 shadow-lg text-white">
                  <h3 className="text-2xl text-center font-bold mb-4">
                    Conoce nuestros planes
                  </h3>

                  <div className="flex flex-col sm:flex-row justify-center gap-4 text-center">
                    <div className="flex-1 bg-white text-purple-700 rounded-lg p-4 shadow hover:scale-105 transform transition">
                      <p className="font-semibold text-lg mb-2">Plan J</p>
                      <p className="text-xl font-bold">$19.000</p>
                    </div>
                    <div className="flex-1 bg-white text-purple-700 rounded-lg p-4 shadow hover:scale-105 transform transition">
                      <p className="font-semibold text-lg mb-2">Plan 10</p>
                      <p className="text-xl font-bold">$22.000</p>
                    </div>

                    <div className="flex-1 bg-white text-purple-700 rounded-lg p-4 shadow hover:scale-105 transform transition">
                      <p className="font-semibold text-lg mb-2">Plan 20</p>
                      <p className="text-xl font-bold">$25.000</p>
                    </div>

                    <div className="flex-1 bg-white text-purple-700 rounded-lg p-4 shadow hover:scale-105 transform transition">
                      <p className="font-semibold text-lg mb-2">Plan 30</p>
                      <p className="text-xl font-bold">$28.000</p>
                    </div>
                  </div>
                </div>

                <div className="bg-purple-100 rounded-xl p-6 my-6 shadow-lg">
                  <h2 className="text-2xl font-bold text-center text-purple-800 mb-4">
                    Tutoriales
                  </h2>

                  <div className="flex flex-col sm:flex-row justify-center gap-6">
                    <a
                      href="https://www.youtube.com/watch?v=bvs8uyuSJc4"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 bg-white rounded-lg p-4 shadow hover:shadow-lg transition transform hover:scale-105 text-center"
                    >
                      <p className="font-semibold text-purple-700 mb-2">Instructivo Ingreso al panel de usuario</p>
                      <p className="text-sm text-gray-600">Ver tutorial en YouTube</p>
                    </a>

                    <a
                      href="https://www.youtube.com/watch?v=3vcNGER4TZ8"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 bg-white rounded-lg p-4 shadow hover:shadow-lg transition transform hover:scale-105 text-center"
                    >
                      <p className="font-semibold text-purple-700 mb-2">Instructivo para subir comprobante de pago</p>
                      <p className="text-sm text-gray-600">Ver tutorial en YouTube</p>
                    </a>
                  </div>
                </div>

              </>
            )}
          </div>

          {/* Card de Pagos */}
          <div className="bg-white/80 backdrop-blur shadow-xl rounded-2xl p-6 transition hover:scale-[1.01]">
            <h2 className="text-xl font-semibold text-gray-700 text-center">
              Historial de Pago 2025
            </h2>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm text-gray-700 border">
                <thead className="bg-gray-200 text-center">
                  <tr>
                    <th className="px-3 py-2 border">#</th>
                    <th className="px-3 py-2 border">Mes</th>
                    <th className="px-3 py-2 border">Estado</th>
                    <th className="px-3 py-2 border">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {userData?.Conexion[0]?.Comprobantes.map((comp, i) => (
                    <tr key={i} className="text-center">
                      <td className="border px-2 py-2">{i + 1}</td>
                      <td className="border px-2 py-2">{comp.mes}</td>
                      <td className="border px-2 py-2">
                        {comp.pago ? (
                          <FaCheck className="text-green-500 inline" />
                        ) : (

                          <MdClose className="text-red-500 inline" />
                        )}
                      </td>
                      <td className="border px-2 py-2">
                        {comp.pago ? (
                          comp.link && comp.link.startsWith("http") ? (

                            <a
                              href={comp.link}
                              target="_blank"
                              rel="noreferrer"
                              className="text-blue-500 underline cursor-pointer"
                            >
                              Ver
                            </a>
                          ) : (

                            <span className="text-gray-700 italic">
                              {comp.link}
                            </span>
                          )
                        ) : (
                          <button
                            className="bg-purple-700 text-white px-3 py-1 cursor-pointer rounded hover:bg-purple-800"
                            onClick={() => setShowModal(true)}
                          >
                            Informar
                          </button>
                        )}
                      </td>



                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="bg-gray-300 my-5 rounded-md p-4 text-sm text-gray-700">
              <p>
                <strong>Estimados clientes:</strong>
              </p>

              <p className="my-2">
                Las boletas de pago son enviadas al correo electrónico registrado.
                Deberán abonarla utilizando los medios de pago detallados en la misma.
              </p>



              <p className="my-2">
                Para evitar la suspensión del servicio, nuestro sistema cuenta con <strong>tres fechas de vencimiento</strong>:
              </p>


            </div>

          </div>
        </div>
      </div>

      <Footer />

      {/* MODAL */}
      <ModalContainer show={showModal} setShow={() => setShowModal(false)}>
        <PaymentForm onClose={() => setShowModal(false)} />
      </ModalContainer>
    </div>
  );
};

export default Home;
